interface List<T = any> {
  results: T[]
  limit: number
  offset: number | string
  count: number
  cursor: any
}

export interface ListFormatArray<T = any> extends Array<T> {
  meta: Omit<List, "results">
}

export default function listFormat<T = any>(list: List<T>): ListFormatArray<T> {
  const {limit, offset, count, results, cursor} = list
  const mutated: ListFormatArray<T> = [...results]
  mutated.meta = {
    limit,
    offset,
    count,
    cursor
  }

  return mutated
}
